import axios from 'axios';
import getHeaders from '../../constants/headers';
import { PRICElIST_BASE_URL } from '../BaseURL';

export const getGarmentRemarks = brandId => {
  return axios({
    method: 'get',
    url:
      PRICElIST_BASE_URL +
      '/api/secure/v1/brand/' +
      brandId +
      '/remark',
    headers: getHeaders(),
  });
};

export const postGarmentRemarks = (brandId, data) => {
  return axios({
    method: 'post',
    url: PRICElIST_BASE_URL + '/api/secure/v1/brand/' + brandId + '/remark',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const putGarmentRemarks = (brandId, data) => {
  return axios({
    method: 'put',
    url: PRICElIST_BASE_URL + '/api/secure/v1/brand/' + brandId + '/remark',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getGarmentRemarksType = () => {
  return axios({
    method: 'get',
    url:
      PRICElIST_BASE_URL +
      '/api/secure/v1/garment-remark-type/',
    headers: getHeaders(),
  });
};


export const getGarmentRemarksV2 = brandId => {
  return axios({
    method: 'get',
    url:
      PRICElIST_BASE_URL +
      '/api/secure/v2/brand/' +
      brandId +
      '/remark',
    headers: getHeaders(),
  });
};

export const getGarmentRemarksTypeRemarkList = (brandId, typeId) => {
  return axios({
    method: 'get',
    url:
      PRICElIST_BASE_URL +
      '/api/secure/v1/brand/' +
      brandId + '/type/' + typeId +
      '/remark',
    headers: getHeaders(),
  });
};


// curl --location '/api/secure/v2/brand/1/remark' \
// --header 'Authorization: Bearer eyJhbGciOiJIUzUxMiJ9.eyJhdXRob3JpdGllcyI6WyJST0xFX1NVUEVSX0FETUlOIl0sImRldmljZVRva2VuIjoiZDQxZDhjZDk4ZjAwYjIwNGU5ODAwOTk4ZWNmODQyN2UiLCJsb2dnZWRJblVzZXJJZCI6Ik9JVDM3NTcyIiwibG9nZ2VkSW5Vc2VyQnJhbmRJZCI6IjEiLCJzdWIiOiIxIiwiaWF0IjoxNzMxNDIzMDExLCJleHAiOjE3MzIwMjc4MTF9.8PyEjWa5Y2sn5pyyVPQixeWlccvB5cRtzIlXolSpXZpEFQDuQtWSXkfxC9eTMrxYVuGeSk5MJlJMoJQw6P_zEw' \
// --header 'Cookie: JSESSIONID=3D908B5BD3B90D17B77D4BA865E7DCC9'

// curl --location 'https://dhobicart.in/pricelist/api/secure/v1/brand/1/type/1/remark' \
// --header 'Authorization: Bearer eyJhbGciOiJIUzUxMiJ9.eyJhdXRob3JpdGllcyI6WyJST0xFX1NVUEVSX0FETUlOIl0sImRldmljZVRva2VuIjoiZDQxZDhjZDk4ZjAwYjIwNGU5ODAwOTk4ZWNmODQyN2UiLCJsb2dnZWRJblVzZXJJZCI6Ik9JVDM3NTcyIiwibG9nZ2VkSW5Vc2VyQnJhbmRJZCI6IjEiLCJzdWIiOiIxIiwiaWF0IjoxNzMxNDIzMDExLCJleHAiOjE3MzIwMjc4MTF9.8PyEjWa5Y2sn5pyyVPQixeWlccvB5cRtzIlXolSpXZpEFQDuQtWSXkfxC9eTMrxYVuGeSk5MJlJMoJQw6P_zEw' \
// --header 'Cookie: JSESSIONID=E0AB1128453F1B048734B0FFECAAEC04'